<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      :before-close="onClickClose"
    >
      <div class="header_content">
        <div>
          <span>{{ deviceInformation.deviceName }}</span
          ><i class="el-icon-edit" @click="onClickEditName"></i>
        </div>
        <div>{{ $t("lang.租客姓名") }}：{{ deviceInformation.nickName }}</div>
        <div>{{ $t("lang.联系电话") }}：{{ deviceInformation.phone }}</div>
        <div class="dividingLine"></div>
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          @click="onClickDelDevice"
          >{{ $t("lang.删除设备") }}</el-button
        >
      </div>
      <!-- Tabs -->
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        :class="[$i18n.locale == 'zh-CN' ? '' : 'my_el_tabs']"
      >
        <el-tab-pane :label="$t('lang.设备信息')" name="1">
          <DeviceInfo ref="deviceInfoRef" />
        </el-tab-pane>
        <el-tab-pane :label="$t('lang.费用明细')" name="2">
          <ExpenseDetail ref="expenseDetailRef" />
        </el-tab-pane>
        <el-tab-pane :label="$t('lang.操作记录')" name="3">
          <OperationRecord ref="operationRecordRef" />
        </el-tab-pane>
        <el-tab-pane :label="$t('lang.充值记录')" name="4">
          <RechargeRecord ref="rechargeRecordRef" />
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <DeviceEditDialog ref="deviceEditDialogRef" />
  </div>
</template>

<script>
import DeviceInfo from "./son-tab/device-info.vue";
import ExpenseDetail from "./son-tab/expense-detail.vue";
import OperationRecord from "./son-tab/operation-record.vue";
import RechargeRecord from "./son-tab/recharge-record.vue";
import DeviceEditDialog from "../dialog/deviceEdit-dialog.vue";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  components: {
    DeviceInfo,
    ExpenseDetail,
    OperationRecord,
    RechargeRecord,
    DeviceEditDialog,
  },
  data() {
    return {
      drawer: false,
      /**选中tab */
      activeName: "1",
      /**设备id */
      pointId: 0,
      /**设备详细信息 */
      deviceInformation: "",
      deviceType: 0,
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      landlordEquipmentDelete: "ZD_LandlordEquipmentDelete",
      landlordWaterEquipmentDelete: "ZD_LandlordWaterEquipmentDelete",
      meterDeviceDetails: "ZD_MeterDeviceDetails",
      meterDeviceWaterDetails: "ZD_MeterDeviceWaterDetails",
    }),
    handleClick() {
      switch (this.activeName) {
        case "1":
          // this.$refs.deviceInfoRef.dataShow(this.deviceInformation);
          break;
        case "2":
          this.$refs.expenseDetailRef.getOperationRecord(
            this.pointId,
            this.deviceType
          );
          break;
        case "3":
          this.$refs.operationRecordRef.getOperationRecord(
            this.pointId,
            this.deviceType
          );
          break;
        case "4":
          this.$refs.rechargeRecordRef.getRechargeRecord(
            this.pointId,
            this.deviceType,
            this.deviceInformation.nickName,
            this.deviceInformation.phone,
            this.deviceInformation.deviceName
          );
          break;
      }
    },
    async showDialog(pointId, deviceType) {
      let res = {};
      this.activeName = "1";
      this.drawer = true;
      this.pointId = pointId;
      this.deviceType = deviceType;
      switch (deviceType) {
        case 0:
          res = await this.meterDeviceDetails({ pointId: pointId });
          if (res.success !== 1) return;
          this.deviceInformation = res.value;
          this.$refs.deviceInfoRef.dataShow(res.value, 0);
          this.$refs.deviceInfoRef.monetary = localStorage.getItem("monetary");
          break;
        case 1:
          res = await this.meterDeviceWaterDetails({ pointId: pointId });
          if (res.success !== 1) return;
          this.deviceInformation = res.value;
          this.$refs.deviceInfoRef.dataShow(res.value, 1);
          this.$refs.deviceInfoRef.monetary = localStorage.getItem("monetary");
          break;
        default:
          break;
      }
      /**初始化数据 */
      this.$refs.expenseDetailRef.monthsQuery = moment().format(
        "YYYY-MM-01 00:00:00"
      );
      this.$refs.operationRecordRef.monthsQuery = moment().format(
        "YYYY-MM-01 00:00:00"
      );
    },
    /**修改名称 */
    onClickEditName() {
      this.$refs.deviceEditDialogRef.dialogVisibleShow(
        1,
        this.deviceInformation
      );
    },
    /**删除设备 */
    onClickDelDevice() {
      this.$confirm(
        this.$t("lang.您是否确认删除该设备"),
        this.$t("lang.提示"),
        {
          confirmButtonText: this.$t("lang.确定"),
          cancelButtonText: this.$t("lang.取消"),
          type: "warning",
        }
      )
        .then(async () => {
          let res = {};
          switch (this.deviceType) {
            case 0:
              res = await this.landlordEquipmentDelete({
                pointId: this.deviceInformation.pointId,
              });
              if (res.success !== 1) return;
              break;
            case 1:
              res = await this.landlordWaterEquipmentDelete({
                pointId: this.deviceInformation.pointId,
              });
              if (res.success !== 1) return;
              break;
            default:
              break;
          }

          this.$message({
            type: "success",
            message: this.$t("lang.删除成功"),
          });
          this.drawer = false;
          this.$parent.onClickQuery();
        })
        .catch(() => {});
    },
    onClickClose() {
      this.drawer = false;
      this.$parent.onClickQuery();
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-drawer {
  padding: 41px 30px 0 30px;
  width: 657px !important;
  color: #666;
}
.header_content {
  font-size: 14px;
  position: relative;
  div:first-child {
    font-weight: bold;
    font-size: 16px;
    i {
      margin-left: 10px;
      color: #999;
      cursor: pointer;
    }
  }
  div:nth-of-type(2) {
    margin: 20px 0 15px 0;
  }
  .el-button {
    border-radius: 4px;
    min-width: 96px;
    height: 28px;
    padding: 8px 10px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.dividingLine {
  height: 4px;
  background: #e4e7ed;
  margin: 15px 0;
}
/deep/.el-tabs__nav .el-tabs__item {
  padding: 0 60px;
  height: 45px;
}
.my_el_tabs {
  /deep/.el-tabs__nav .el-tabs__item {
    padding: 0 40px 0 0 !important;
    height: 45px;
  }
  /deep/.el-tabs__nav .el-tabs__item:last-child {
    padding: 0 !important;
  }
}
</style>
